import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExclamationTriangle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="exclamation-triangle, error, warning, alert"><path d="M12 9.75V13.75M12 16.24V16.25M12 3.25L2.5 19.25H21.5L12 3.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExclamationTriangle;
